<template>
	<div class="container">
		<div class="content">
			<div class="card">
				<h3 class="title">{{ $t('rtr_wallet_account-assets.title2') }}</h3>
				<div v-if="0" class="search_area">
					<input
						type="text"
						:placeholder="this.$t('input.placeholder.search_assets')"
						v-model="searchKeyword"
					/>
					<a class="search_icon SEARCH"></a>
				</div>
				<ul v-if="0" class="tab_area">
					<li :class="{ selected: selectedTab === 1 }">
						<a class="tab_item" @click="tabSelect(1)"
							><span>{{ $t('rtr_wallet_account-assets.tab1') }}</span></a
						>
					</li>
					<li :class="{ selected: selectedTab === 2 }">
						<a class="tab_item" @click="tabSelect(2)"
							><span>{{ $t('rtr_wallet_account-assets.tab2') }}</span></a
						>
					</li>
				</ul>
				<div class="asset_list_wrap">
					<div>
						<!--                자산 탭 표시-->
						<div v-if="selectedTab === 1">
							<ul class="asset_area">
								<li v-for="item in allAssets" :key="item.seq">
									<input
										:id="item.code"
										type="radio"
										class="assets_list_item"
										name="assets"
										:value="item.seq"
										v-model="selectedAssetSeq"
									/>
									<label class="asset_box asset_list_box" :for="item.code">
										<span
											:class="['icon ' + item.code, 'medium', 'mr_4']"
										></span>
										<div>
											<p class="code mb_4">{{ item.code }}</p>
											<p class="name">{{ item.title }}</p>
										</div>
									</label>
									<span
										:class="[{ bookmarked: item.bookmark === 'Y' }, 'STAR']"
										@click="favoriteAssetHandler(item.seq)"
									></span>
								</li>
							</ul>
						</div>
						<!--                즐겨찾기 탭-->
						<div v-if="selectedTab === 2">
							<ul class="asset_area">
								<template v-for="item in allAssets" :key="item.seq">
									<li v-if="item.bookmark === 'Y'">
										<input
											:id="item.code"
											type="radio"
											class="assets_list_item"
											name="assets"
											:value="item.seq"
											v-model="selectedAssetSeq"
										/>
										<label class="asset_box asset_list_box" :for="item.code">
											<span
												:class="['icon ' + item.code, 'medium', 'mr_4']"
											></span>
											<div>
												<p class="code mb_4">{{ item.code }}</p>
												<p class="name">{{ item.title }}</p>
											</div>
										</label>
										<span
											:class="[{ bookmarked: item.bookmark === 'Y' }, 'STAR']"
											@click="favoriteAssetHandler(item.seq)"
										></span>
									</li>
								</template>
							</ul>
						</div>
					</div>
				</div>

				<!--          링크 버튼 -->
				<div v-if="0" class="d_flex justify_between link_area mb_10">
					<div class="flex_grow mr_10">
						<router-link :to="{ name: 'pay-payment' }">
							<div id="send" class="card type_link send bg_black mb_0">
								<p class="fc_white">{{ $t('rtr_auth-dashboard.send') }}</p>
							</div>
						</router-link>
					</div>
					<div class="flex_grow mr_10">
						<router-link :to="{ name: 'pay-deposit' }">
							<div id="request" class="card type_link request bg_red mb_0">
								<p class="fc_white">{{ $t('rtr_auth-dashboard.request') }}</p>
							</div>
						</router-link>
					</div>
					<div class="flex_grow">
						<router-link :to="{ name: 'activity' }">
							<div id="history" class="card type_link history mb_0">
								<p>{{ $t('rtr_auth-dashboard.history') }}</p>
							</div>
						</router-link>
					</div>
				</div>
				<div v-if="0" class="d_flex justify_between link_area mb_10">
					<div class="flex_grow mr_10">
						<router-link :to="{ name: 'pay-exchange' }">
							<div id="send" class="card type_link exchange bg_black mb_0">
								<p class="fc_white">{{ $t('menu.pay-exchange') }}</p>
							</div>
						</router-link>
					</div>
					<div class="flex_grow mr_10">
						<router-link :to="{ name: 'pay-c2c' }">
							<div id="request" class="card type_link c2c bg_red mb_0">
								<p class="fc_white">{{ $t('menu.pay-c2c') }}</p>
							</div>
						</router-link>
					</div>
					<div class="flex_grow">
						<router-link :to="{ name: 'activity-exchange' }">
							<div id="history" class="card type_link activity-exchange mb_0">
								<p>{{ $t('menu.activity-exchange') }}</p>
							</div>
						</router-link>
					</div>
				</div>
				<div v-if="0" class="d_flex justify_between link_area mb_10">
					<div class="flex_grow mr_10">
						<router-link :to="{ name: 'activity-c2c' }">
							<div id="send" class="card type_link activity-c2c bg_black mb_0">
								<p class="fc_white">{{ $t('menu.activity-c2c') }}</p>
							</div>
						</router-link>
					</div>
					<div class="flex_grow mr_10">
						<router-link :to="{ name: 'user-inquiry' }">
							<div id="request" class="card type_link user-inquiry bg_red mb_0">
								<p class="fc_white">{{ $t('cs.inquiry.inquiry') }}</p>
							</div>
						</router-link>
					</div>
					<div class="flex_grow">
						<router-link :to="{ name: 'user-inquiry_list' }">
							<div id="history" class="card type_link user-inquiry_list mb_0">
								<p>{{ $t('cs.inquiry.list') }}</p>
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div class="status_icon error"></div>
		<p class="mb_40">{{ $t('rtr_wallet_account-assets.text1') }}</p>

		<button class="button_bg_red button_m" @click="messageModal = false">
			{{ $t('rtr_auth-register.confirm') }}
		</button>
	</ModalMessageM>
	<ModalViewM v-if="assetsModal" @closeModal="closeAssetModal">
		<template #title>
			<h3 class="modal_title_m tal">{{ assetModalTitle }}</h3>
		</template>
		<div v-if="!isRegistMode" class="assets_detail_wrap">
			<!--        자산 목록 클릭 했을 경우-->
			<div v-if="selectedAccount">
				<div class="bg_black_box">
					<div class="asset_box mb_20">
						<span :class="[selectedAccount.asset_code, 'medium']"></span>
						<div>
							<p class="code mb_4">
								{{ selectedAccount.asset_code }}
							</p>
							<p class="name">
								{{ selectedAccount.asset_title }}
							</p>
						</div>
					</div>
					<div class="num_unit">
						<p class="num">{{ selectedAccount.balance }}</p>
						<p class="unit">{{ selectedAccount.asset_code }}</p>
					</div>
					<template v-if="0 && selectedAccount.asset_code === 'USDT'">
						<!--              USDT 충전하기-->
						<div class="button_area justify_between">
							<button class="button_blue pa_10" @click="notYet">
								{{ $t('account-wallet.btn_charge') }}
							</button>
							<div class="d_flex">
								<button
									class="button_white mr_5 pa_10"
									@click="toSend(selectedAccount.seq)"
								>
									{{ $t('button.send') }}
								</button>
								<button
									class="button_bg_red pa_10"
									@click="toDeposit(selectedAccount.seq)"
								>
									{{ $t('button.request') }}
								</button>
							</div>
						</div>
					</template>

					<template v-else>
						<div class="button_area">
							<button
								class="button_white w50 mr_5"
								@click="toSend(selectedAccount.seq)"
							>
								{{ $t('button.send') }}
							</button>
							<button
								class="button_bg_red w50"
								@click="toDeposit(selectedAccount.seq)"
							>
								{{ $t('button.request') }}
							</button>
						</div>
					</template>
				</div>
				<div class="qr_area">
					<p
						v-if="0 && selectedAccount.asset_code === 'USDT'"
						class="if_USDT mt_16 mb_10"
					>
						{{ $t('rtr_wallet_account-assets.account') }}
					</p>
					<ul v-else class="tab_area mt_16">
						<li
							:class="[{ selected: qrTab === 'account' }, 'tab_item', 'all']"
							@click="qrTab = 'account'"
						>
							<a>{{ $t('rtr_wallet_account-assets.account') }}</a>
						</li>
						<li
							v-if="selectedAccount.address"
							:class="[{ selected: qrTab === 'address' }, 'tab_item', 'all']"
							@click="qrTab = 'address'"
						>
							<a>{{ $t('rtr_wallet_account-assets.address') }}</a>
						</li>
					</ul>
					<swiper
						:slidesPerView="1"
						:pagination="true"
						:navigation="true"
						:modules="modules"
						class="mb_15"
						@swiper="onSwiper"
						@slideChange="onSwiperChange"
					>
						<swiper-slide>
							<div class="qr_image_wrap">
								<Qrcode
									id="accountQr"
									:color="{ dark: '#000000ff', light: '#ffffffff' }"
									type="image/png"
									:quality="1"
									:margin="1"
									:value="selectedAccount.account_number"
								/>
							</div>
							<div class="qr_download">
								<a @click="qrDownload('accountQr')"
									><img
										src="@/assets/images/icon/download.png"
										alt="qr download icon"
									/>
									download</a
								>
							</div>

							<p class="mb_8">
								{{ selectedAccount.account_number }}
							</p>
							<button
								class="button_copy mb_40"
								@click="copyClipboard('account_number')"
							>
								{{ $t('account-wallet.btn_copy') }}
							</button>
						</swiper-slide>
						<!--            선택된 자산에 주소가 있을경우에만 표출-->
						<swiper-slide v-if="selectedAccount.address">
							<div class="qr_image_wrap">
								<Qrcode
									id="addressQr"
									:color="{ dark: '#000000ff', light: '#ffffffff' }"
									type="image/png"
									:quality="1"
									:margin="1"
									:value="selectedAccount.address"
								/>
							</div>
							<div class="qr_download">
								<a @click="qrDownload('addressQr')"
									><img
										src="@/assets/images/icon/download.png"
										alt="qr download icon"
									/>
									download</a
								>
							</div>
							<p class="address mb_8">{{ selectedAccount.address }}</p>
							<button
								class="button_copy mb_40"
								@click="copyClipboard('address')"
							>
								{{ $t('account-wallet.btn_copy') }}
							</button>
						</swiper-slide>
					</swiper>
				</div>
			</div>
			<!--                자산 없을때-->
			<div v-else>
				<a class="box_dashed" @click="toAccountRegist">
					<span class="icon ADD"></span>
					<p>{{ $t('rtr_wallet_account-assets.text2') }}</p>
				</a>
			</div>
		</div>
		<div v-else>
			<account-register
				:asset-info="selectedAsset"
				@closeRegist="this.isRegistMode = false"
			/>
		</div>
	</ModalViewM>
</template>

<script>
import '@/assets/css/asset.m.css';
import { mapGetters } from 'vuex';
import { Pagination, Navigation } from 'swiper';
import AccountRegister from '@/components/AccountRegister';
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import useClipboard from 'vue-clipboard3';
export default {
	name: 'AssetsList.m',
	components: {
		AccountRegister,
		ModalViewM,
		ModalMessageM,
	},
	data() {
		return {
			selectedTab: 1,
			qrTab: 'account',
			favoriteAssetKey:
				'favoriteAsset_' + this.$store.state.auth.member_info.seq,
			favoriteAssetsSeq: [],
			selectedAssetSeq: null,
			isRegistMode: false,
			messageModal: false,
			assetsModal: false,
			searchKeyword: '',
			modules: [Pagination, Navigation],
			swiper: null,
		};
	},
	watch: {
		selectedAssetSeq() {
			this.isRegistMode = false;
			if (this.selectedAssetSeq !== null) {
				this.assetsModal = true;
			}
		},
		qrTab(value) {
			const index = value === 'account' ? 0 : 1;
			if (value) this.swiper.slideTo(index);
		},
	},
	computed: {
		...mapGetters('assets', ['assets']),
		...mapGetters('account', ['accounts']),
		allAssets() {
			const list = [];
			const result = [];
			this.assets.forEach(item => {
				if (item.code === 'USDT') {
					list.unshift(item);
				} else {
					list.push(item);
				}
			});
			list.forEach((item, idx) => {
				const index = this.favoriteAssetsSeq.indexOf(item.seq);
				if (index !== -1) list[idx] = { bookmark: 'Y', ...item };
				else list[idx] = { bookmark: 'N', ...item };
			});

			result.push(list[0]);

			list.forEach(item => {
				if (item.code === 'USDT') return;
				if (item.bookmark === 'Y') result.push(item);
			});
			list.forEach(item => {
				if (item.code === 'USDT') return;
				if (item.bookmark === 'N') result.push(item);
			});

			if (this.searchKeyword) {
				return list.filter(item => {
					return (
						item.code
							.toLowerCase()
							.includes(this.searchKeyword.toLowerCase()) ||
						item.title.toLowerCase().includes(this.searchKeyword.toLowerCase())
					);
				});
			} else {
				return result;
			}
		},
		selectedAsset() {
			return this.assets.find(item => {
				return item.seq === parseInt(this.selectedAssetSeq);
			});
		},
		selectedAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === parseInt(this.selectedAssetSeq);
			});
		},
		assetModalTitle() {
			return this.isRegistMode
				? this.$t('rtr_wallet_account-assets.title3')
				: this.$t('rtr_wallet_account-assets.title2');
		},
	},
	mounted() {
		if (localStorage.getItem(this.favoriteAssetKey)) {
			this.favoriteAssetsSeq = JSON.parse(
				localStorage.getItem(this.favoriteAssetKey),
			);
		}
	},
	methods: {
		onSwiper(swiper) {
			this.swiper = swiper;
		},
		onSwiperChange(e) {
			this.qrTab = e.activeIndex === 0 ? 'account' : 'address';
		},
		tabSelect(e) {
			this.selectedTab = e;
		},
		favoriteAssetHandler(assetSeq) {
			const index = this.favoriteAssetsSeq.indexOf(assetSeq);
			if (index === -1) {
				// if (this.favoriteAssetsSeq.length === 5) {
				// 	this.messageModal = true;
				// 	return false;
				// }
				this.favoriteAssetsSeq.push(assetSeq);
			} else {
				this.favoriteAssetsSeq.splice(index, 1);
			}
			localStorage.setItem(
				this.favoriteAssetKey,
				JSON.stringify(this.favoriteAssetsSeq),
			);
		},
		toAccountRegist() {
			this.isRegistMode = true;
		},
		toSend(seq) {
			this.$router.push({
				name: 'pay-payment',
				query: { accountSeq: seq },
			});
		},
		toDeposit(seq) {
			this.$router.push({
				name: 'pay-deposit',
				query: { accountSeq: seq },
			});
		},
		qrDownload(id) {
			const dataUrl = document.getElementById(id).src;
			const link = document.createElement('a');
			link.href = dataUrl;
			link.download = 'qrcode';
			link.click();
		},
		copyClipboard(key) {
			try {
				useClipboard().toClipboard(this.selectedAccount[key]);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		closeAssetModal() {
			this.selectedAssetSeq = null;
			this.qrTab = 'account';
			this.assetsModal = false;
		},
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
	created() {
		if (this.$route.query.assetSeq) {
			this.selectedAssetSeq = this.$route.query.assetSeq;
		}
	},
};
</script>
